<button mat-icon-button matBadge="{{ unreadCount }}" matBadgeColor="warn"
  [matMenuTriggerFor]="menu">
  <mat-icon>notifications</mat-icon>
</button>

<mat-menu #menu="matMenu">
  <ng-container *ngIf="isLoading">
    <button mat-menu-item disabled>
      <mat-icon>hourglass_empty</mat-icon>
      Carregando...
    </button>
  </ng-container>

  <ng-container *ngIf="!isLoading && notifications.length > 0">
    <ng-container *ngFor="let notification of notifications">
      <button mat-menu-item (click)="openNotification(notification)">
        <mat-icon>notifications_active</mat-icon>
        {{ notification.message }}
      </button>
    </ng-container>

    <mat-divider></mat-divider>
    <button mat-menu-item (click)="clearAll()">
      <mat-icon>clear_all</mat-icon>
      Marcar todas como lidas
    </button>
  </ng-container>

  <ng-container *ngIf="!isLoading && notifications.length === 0">
    <button mat-menu-item disabled>
      <mat-icon>done</mat-icon>
      Nenhuma nova notificação
    </button>
  </ng-container>
  <button mat-menu-item (click)="openNotificationSettings()">
    <mat-icon>settings</mat-icon>
    Configurações
  </button>
</mat-menu>
